/**
 * Contains all school closings page components.
 */
import { ComponentManager } from 'js-component-framework';
import domContentLoaded from 'utils/domContentLoaded';
import weatherAlertsTabsConfig from 'components/weatherAlertsTabs';

import '../../scss/weather-alerts-page/index.scss';

// Create instance of the component manager using `nbc-weather-alert-components`
const manager = new ComponentManager('nbc-weather-alert-components');

domContentLoaded(() => {
  manager.initComponents([
    weatherAlertsTabsConfig,
  ]);
});

if (module.hot) {
  module.hot.accept();

  manager.initComponents([
    weatherAlertsTabsConfig,
  ]);
}
